export default __webpack_public_path__ + "static/media/IconDesc_UraniumPellets.256.683c3121.png";